import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will create the connection to Ansible Tower and create your first Runbook.`}</p>
    <h2>{`🚀 TASK: Create the Ansible Tower Connection`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=connections-ansible" target="_blank">🌏 Documentation for the Task: Ansible automation provider</a>
    <p>{`Create the connection to Ansible Tower using the following parameters:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`URL for REST API:      from MY_CONFIGURATION.txt
Authentication type:   User ID/Password
User:                  admin
Password:              from MY_CONFIGURATION.txt
`}</code></pre>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`🔎 The parameters can also be found in your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<strong parentName="p">{`2.3 Configure Runbooks - Ansible Automation Controller`}</strong></p>
    </InlineNotification>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Define`}</inlineCode>{`/`}<inlineCode parentName="p">{`Data and tool connections`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Under `}<inlineCode parentName="p">{`Ansible Automation Controller`}</inlineCode>{`, click on `}<inlineCode parentName="p">{`Add connection`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Connect`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`🔎 Get the data from your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<strong parentName="p">{`2.3 Configure Runbooks - Ansible Automation Controller`}</strong></p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`./tools/11_practicum/get_configuration_info.sh > MY_CONFIGURATION.txt
`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Fill out the fields:`}</p>
            <img parentName="li" {...{
              "src": "./../images/29_runbook.png",
              "alt": "image"
            }}></img>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`URL for REST API:      from MY_CONFIGURATION.txt
Authentication type:   User ID/Password
User:                  admin
Password:              from MY_CONFIGURATION.txt

`}</code></pre>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Done`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Make sure that the Connection Status turn green after a few seconds`}</p>
          </li>
        </ol>
        <h2>{`Check integration`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`In the `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode>{` “Hamburger” Menu select `}<inlineCode parentName="p">{`Operate`}</inlineCode>{`/`}<inlineCode parentName="p">{`Automations`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select tab `}<inlineCode parentName="p">{`Actions`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Verify that the Ansible Playbooks have been imported`}</p>
            <img parentName="li" {...{
              "src": "./../images/30_runbook.png",
              "alt": "image"
            }}></img>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <h2>{`🚀 TASK: Create a runbook`}</h2>
    <a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/4.6.0?topic=library-create-runbook" target="_blank">🌏 Documentation for the Task: Creating a runbook</a>
    <p>{`Create a Runbook based on the `}<inlineCode parentName="p">{`CP4AIOPS Mitigate Robotshop Ratings Outage`}</inlineCode>{` Ansible Playbook.`}</p>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`🔎 The parameters can also be found in your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<inlineCode parentName="p">{`2.4 Configure Runbooks - Runbook Parameters`}</inlineCode>{` `}</p>
    </InlineNotification>
    <Accordion mdxType="Accordion">
      <AccordionItem title="💡 Solution?" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Select tab `}<inlineCode parentName="p">{`Runbooks`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create Runbook`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Name it `}<inlineCode parentName="p">{`RobotShop Mitigate MySQL Problem`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Add automated step`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`CP4AIOPS Mitigate Robotshop Ratings Outage`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Select this action`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Mapping`}</inlineCode>{` / `}<inlineCode parentName="p">{`Select`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select `}<inlineCode parentName="p">{`New runbook parameter`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/31_runbook.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Select tab `}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`🔎 Get the data from your configuration file `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` - section  `}<inlineCode parentName="p">{`2.4 Configure Runbooks - Runbook Parameters`}</inlineCode>{` `}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`./tools/11_practicum/get_configuration_info.sh > MY_CONFIGURATION.txt
`}</code></pre>
            <img parentName="li" {...{
              "src": "./../images/32_runbook.png",
              "alt": "image"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Replace `}<inlineCode parentName="p">{`PROVIDE: my_k8s_apiurl and my_k8s_apikey`}</inlineCode>{` in field `}<inlineCode parentName="p">{`Default value (optional)`}</inlineCode>{` with the `}<strong parentName="p">{`🗺️ Value`}</strong>{` from the script`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save`}</inlineCode>{` again`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Actions`}</inlineCode>{` and `}<inlineCode parentName="p">{`Publish`}</inlineCode></p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      